import React from "react";
import HttpServices from "../../utils/Http.services";
import { translate } from "../../utils/useful";
import LoaderButton from "../LoaderButton";
import RippleButton from "../RippleButton";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

class TriggerWidget extends React.Component {

    state = {
    }

    submit = () => {
        HttpServices.request("postActionTrigger", {dashboard:this.props.dashboard?._id, trigger: this.props.data.id, thing: this.props.data.thing, value: true }, (fetchResult, fetchError, status) => {
            console.log(fetchResult)
            console.log(fetchError)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.submittedSuccesfully', description: '{{lang}}info.dataSubmittedSuccessfully' })

        })
    }


    render() {
        // console.log(this.props.data)
        return (

            <div className="w-100 h-100 flexcc py-3" style={{ flexDirection: 'column' }} >
                {/* <LoaderButton
                    onClick={this.submit}
                    isLoading={this.state.isLoading}
                    text={translate("submit")}
                    type={"Oval"}
                    className="mt-2 mb-2"
                    buttonStyle={{ outline: 'none', backgroundColor: ' rgb(51, 98, 229)',  cursor: 'pointer', padding: '7px 7x',width:80,height:80, borderRadius: '50%', fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                    width={40}
                    height={40}
                    color={'#202020'}
                /> */}
                <div className="w-100 px-4 h-100 flexcc">
                    <RippleButton label={this.props.data?.label} onClick={this.submit} color={"rgb(51, 98, 229)"} />
                </div>

                {/* <p className=" mt-1" style={{ color: '#9ab', fontSize: 12 }}>This is the description</p> */}


            </div>
        )
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TriggerWidget);
